import React, { useMemo, useRef } from 'react';
import { UIGameActionButton } from '../../../common/UIGameActionButton/index.ts';
import { UIGameResourceCardsTooltipContent } from '../../../common/UIGameResourceCardsTooltipContent/index.ts';
import { getCardsForPiece } from '@colonist/game-card-types';
import { PieceTypes } from '@colonist/game-base-types';
import { useActionButtonCommonErrors } from '../utils.ts';
import { SETTLEMENT_IMAGE_PATH } from '../../../utils/gamePieces.ts';
import { useGameStore } from '../../../store/GameStoreContext.ts';
import { usePlayerValidators } from '../../../store/selectors/usePlayerValidators.ts';
import { ActionState } from '@colonist/game-states';
import { useCurrentStateValidator } from '../../../store/selectors/useCurrentStateValidator.ts';
import { HiddenUIElement } from '@colonist/game-beginner-mode';
import clsx from 'clsx';
import styles from '../UIGameActionButtonContainer.module.scss';
import { useMechanicValidatorSettlement } from '../../../store/selectors/useMechanicValidatorSettlement.ts';
const cardsToBuildSettlement = getCardsForPiece(PieceTypes.Settlement);
export const UIGameActionButtonSettlement = ({ className })=>{
    const myColor = useGameStore((state)=>state.myColor);
    const { getPlayerValidator } = usePlayerValidators();
    const currentStateValidator = useCurrentStateValidator();
    const beginnerActionState = useGameStore((state)=>state.gameBeginnerHint.beginnerActionState);
    const tooltipRef = useRef(null);
    const playerValidator = getPlayerValidator(myColor);
    const { errorHelperText, hasCommonErrors } = useActionButtonCommonErrors();
    const { sendBuildSettlement, sendCancelAction, sendClearCornerHighlight } = useGameStore((state)=>state.gameSendEvent);
    const settlementValidator = useMechanicValidatorSettlement();
    const actionStatus = useMemo(()=>{
        if (!settlementValidator) {
            return {
                canTakeAction: false
            };
        }
        const useResources = true;
        const canPlaceSettlementActionStatus = settlementValidator.canPlayerPlaceSettlement(myColor, useResources);
        return canPlaceSettlementActionStatus;
    }, [
        settlementValidator,
        myColor
    ]);
    const triggerFlickerCardsAnimation = ()=>{
        const notEnoughResources = !playerValidator.hasResourceCardsInHand(cardsToBuildSettlement);
        if (notEnoughResources) {
            var _tooltipRef_current;
            (_tooltipRef_current = tooltipRef.current) === null || _tooltipRef_current === void 0 ? void 0 : _tooltipRef_current.triggerFlickerAnimation();
        }
    };
    const isHidden = beginnerActionState === null || beginnerActionState === void 0 ? void 0 : beginnerActionState.hiddenUIElements.includes(HiddenUIElement.SettlementActionButton);
    const disabled = hasCommonErrors || !actionStatus.canTakeAction || isHidden;
    const actionState = currentStateValidator.getPlayerActionState(myColor);
    const isPlacingSettlement = actionState === ActionState.PlaceSettlement && !disabled;
    var _settlementValidator_getSettlementPlayerState_bankSettlementAmount;
    const bankSettlementAmount = (_settlementValidator_getSettlementPlayerState_bankSettlementAmount = settlementValidator === null || settlementValidator === void 0 ? void 0 : settlementValidator.getSettlementPlayerState(myColor).bankSettlementAmount) !== null && _settlementValidator_getSettlementPlayerState_bankSettlementAmount !== void 0 ? _settlementValidator_getSettlementPlayerState_bankSettlementAmount : 0;
    const helperText = errorHelperText || actionStatus.errorMessageIfCantTakeAction;
    const icon = SETTLEMENT_IMAGE_PATH[myColor];
    const onClick = ()=>{
        if (disabled) return;
        if (isPlacingSettlement) {
            sendClearCornerHighlight();
            sendCancelAction();
        } else {
            sendBuildSettlement();
        }
    };
    return /*#__PURE__*/ React.createElement(UIGameActionButton, {
        className: clsx(className, {
            [styles.hidden]: isHidden
        }),
        count: bankSettlementAmount,
        countColor: myColor,
        disabled: disabled,
        helperText: helperText,
        highlight: isPlacingSettlement,
        iconPath: icon,
        onClickActionIfDisabled: triggerFlickerCardsAnimation,
        tooltipCustomMenuComponent: /*#__PURE__*/ React.createElement(UIGameResourceCardsTooltipContent, {
            cardInventory: playerValidator.resourceCards.cards,
            cardsToBuild: cardsToBuildSettlement,
            ref: tooltipRef
        }),
        onClick: onClick
    });
};
